<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">Contents</p>
<p class="toc"><a href="#/acknowledgement">Acknowledgements</a></p>
<p class="toc"><a href="#/introduction">Introduction</a></p>
<p class="toc1"><a href="#/chapter01">1. Mail-Order Murder</a></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">2. Notorious Clem Blood</span></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">3. The Thomson Jewelry Store Robbery and Triple Murder</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">4. The Jealousy of Frank Loeffler</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">5. Potato Masher Murder</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">6. The Tragedy of Charlie Pohlman</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">7. The Mysterious Death of Mina Dekker</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">8. The Day Henry Bedford Went Mad</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">9. The Fiery Temper of Dora Velzy</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">10. The Reformation of Clara Connolly</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">11. Who Killed Josephine Oom?</span></p>
<p class="toc"><span href="#/chapter12" title="Link target outside of Sample">12. The Scarlet Sisterhood of Grand Rapids</span></p>
<p class="toc1"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?e9de894c